import { render, staticRenderFns } from "./TickerMoneyWorksSync.vue?vue&type=template&id=85f036cc&scoped=true&"
import script from "./TickerMoneyWorksSync.vue?vue&type=script&lang=js&"
export * from "./TickerMoneyWorksSync.vue?vue&type=script&lang=js&"
import style0 from "./TickerMoneyWorksSync.vue?vue&type=style&index=0&id=85f036cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f036cc",
  null
  
)

export default component.exports